<template>
    <console-content max-width="1024">
        <v-row align="center" class="mt-3">
            <v-col cols="auto" class="headline text-start">
                핀 발행 (수동)
            </v-col>
        </v-row>
        <v-card class="mt-4">
            <v-card-text>
                <v-row>
                    <v-col cols="6" class="py-0">
                        <v-select v-model="issue._cp" :items="cps.map(cp => ({ ...cp, name: `${cp.name}` }))" item-value="_id" item-text="name" label="CP" :loading="cpLoading" placeholder=" " hide-details />
                    </v-col>
                    <v-col cols="6" class="py-0">
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="6" class="py-0">
                        <v-select v-model="issue.lv" :items="levels" item-text="name" item-value="code" label="발권금액"
                            placeholder=" " hide-details></v-select>
                    </v-col>
                    <v-col cols="6" class="py-0">
                        <v-select v-model="issue.expiration" :items="expirations" item-text="name" item-value="_id"
                            label="만료기간" placeholder=" " hide-details return-object></v-select>
                    </v-col>
                </v-row>
                <v-row class="mt-3">
                    <v-col cols="12" md="6" class="py-0">
                        <v-select v-model="issue.locked" :items="lockedItems" item-text="name" item-value="value"
                            label="잠금상태" placeholder=" " hide-details></v-select>
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                        <v-text-field v-model="issue.quantity" label="수량(개)" placeholder=" " hide-details>
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" :loading="issue.loading" @click="generate">
                    <v-icon left>{{ mdiBarcode }}</v-icon>핀 발행하기
                </v-btn>
            </v-card-actions>
        </v-card>

        <v-card class="mt-4">
            <v-card-actions>
                <v-spacer />
                <v-btn color="green" outlined @click="excel">
                    <v-icon left size="20">{{ mdiMicrosoftExcel }}</v-icon>엑셀 다운로드
                </v-btn>
            </v-card-actions>

            <v-divider />

            <v-data-table :headers="pinHeaders" :items="pins" disable-pagination hide-default-footer class="mt-2">
                <template v-slot:item.gno="{ item }">
                    {{ item.cd + item.lv + item.no.toString().padStart(13, 0) }}
                </template>
                <template v-slot:item.faceamt="{ item }">
                    {{ item.faceamt.format() }}
                </template>
                <template v-slot:item.expiredAt="{ item }">
                    {{ item.expiredAt.toDateTime() }}
                </template>
            </v-data-table>
        </v-card>

    </console-content>
</template>

<script>
import api from "@/api";
import levels from "@/assets/data/levels";

import XLSX from 'xlsx';
import { mdiMicrosoftExcel, mdiBarcode } from '@mdi/js';
import ConsoleContent from "@/components/console/console-content.vue";

export default {
    components: {
        ConsoleContent
    },
    data() {
        return {
            mdiMicrosoftExcel,
            mdiBarcode,

            levels,

            issue: {
                _cp: null,

                type: "manual",
                lv: "xc",
                expiration: { _id: 2, type: "year", value: 5 },
                locked: 0,
                quantity: 0,
                loading: false
            },

            pins: [],
            pinHeaders: [
                { text: "발권번호", align: "center", value: "gno" },
                { text: "핀번호", align: "center", value: "pno" },
                { text: "액면가", align: "center", value: "faceamt" },
                { text: "만료일자", align: "center", value: "expiredAt" }
            ],

            categories: [],

            expirations: [
                { _id: 0, name: "30일", type: "day", value: 30 },
                { _id: 1, name: "60일", type: "day", value: 60 },
                { _id: 2, name: "5년", type: "year", value: 5 }
            ],

            lockedItems: [
                { name: "잠금", value: 1 },
                { name: "잠금해제", value: 0 }
            ],

            cps: [],
            cpLoading: true,
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            var { cps } = await api.console.me.cps.gets({ headers: { limit: 0 } });
            this.cps = cps;

            this.cpLoading = false;
        },

        validate(){
            try{
                if(!this.issue._cp) throw new Error("CP를 선택해주세요");
                if((this.issue.quantity || 0 ) <= 0) throw new Error("수량을 입력해주세요");

                return true;
            }
            catch(error){
                alert(error.message);
            }
            return false;
        },

        ////////////////////////////////////////////////////////////////////////
        // 발권하기
        ////////////////////////////////////////////////////////////////////////
        async generate(){
            let selectedLevel = null
            for(let i = 0; i < this.levels.length; i++) {
                if(levels[i].code === this.issue.lv) {
                    selectedLevel = levels[i]
                }
            }
            if(this.validate()){
                if(confirm(`${selectedLevel.name}권 핀을 ${this.issue.quantity}개 발행하시겠습니까?`)) {
                    this.issue.loading = true;

                        var { pins } = await api.console.pins.issue(this.issue);
            
                        this.pins = pins;
        
                    this.issue.loading = false;
                }
            }
        },

        ////////////////////////////////////////////////////////////////////////
        // 엑셀 다운로드
        ////////////////////////////////////////////////////////////////////////
        excel(){
            var data = [];
            for(var pin of this.pins){
                data.push({
                    "발권번호": pin.cd + pin.lv + pin.no.toString().padStart(13, 0),
                    "핀번호": pin.pno,
                    "액면가": pin.faceamt?.format(),
                    "발행일자": pin.issuedAt?.toDateTime(),
                    "만기일자": pin.expiredAt?.toDateTime()
                });
            }
            var workbook = XLSX.utils.book_new();
            var worksheet = XLSX.utils.json_to_sheet(data);

            XLSX.utils.book_append_sheet(workbook, worksheet, "핀 목록");
            XLSX.writeFile(workbook, "핀 발행목록.xlsx");
        },
    },

    computed: {
        category(){
            return this.categories?.find(category => category._id == this.issue._category) ?? {};
        }
    }
}
</script>
